export default __webpack_public_path__ + "static/media/logo-us-apple.1cf9541b.svg";